import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import logo from '../assets/logo.png';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };
  return (
    <aside className="min-h-screen w-64 bg-gradient-to-b from-green-900 via-green-800 to-green-900 text-white flex flex-col items-center px-0 py-0 shadow-2xl">
      {/* Logo & Brand */}
      <div className="w-full flex flex-col items-center bg-green-900 pt-10 pb-5 border-b border-green-800">
        <img src={logo} alt="Kanhaiya Krushi Logo" className="w-16 h-16 rounded-xl shadow bg-white p-1 mb-2" />
        <h2 className="text-xl font-extrabold tracking-wider mt-1 text-green-200 text-center">Admin Panel</h2>
        <span className="text-xs text-green-300">Kanhaiya Krushi</span>
        <div className="w-11 h-11 rounded-full border-2 border-green-700 flex items-center justify-center bg-green-800 mt-4 mb-1">
          <FaUserCircle size={40} className="text-green-200" />
        </div>
        <span className="text-xs text-green-100">Hello, Admin</span>
      </div>
      <div className="flex flex-col items-center space-y-1 mt-10 flex-1 w-full">
        <button onClick={() => navigate('/admin/dashboard')} className="w-11/12 flex items-center justify-center gap-3 px-3 py-3 mb-4 rounded-xl bg-green-700 hover:bg-green-600 shadow font-semibold text-lg transition-all">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
          Dashboard
        </button>
      </div>
      <button onClick={handleLogout} className="w-11/12 mt-6 mb-8 flex items-center justify-center px-3 py-3 gap-2 rounded-xl bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold shadow transition-all">
        <FaSignOutAlt className="w-5 h-5" /> Logout
      </button>
    </aside>
  );
};

export default AdminSidebar;
